import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ProjectsFacade,
  SharedFacade,
  customDecode,
  customEncode,
  decrypt,
  encrypt,
} from '@piqet-angular/data';
import { ProjectScenarioConsumerDataGridService } from './project-scenario-consumer-data-grid.service';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  CustomModalService,
  StorageTypeEnum,
} from '@piqet-angular/shared';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewportScroller } from '@angular/common';
import { ProjectScenarioRetailDataGridService } from '../project-scenario-retail/project-scenario-retail-data-grid.service';
import { catchError, of, finalize, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'piqet-angular-project-scenario-consumer',
  templateUrl: './project-scenario-consumer.component.html',
  styleUrls: ['./project-scenario-consumer.component.scss'],
})
export class ProjectScenarioConsumerComponent {
  isHideSideBar = false;
  nextRoute: any;
  columnDefs!: ColDef[];
  projectScenarioConsumerPayload: any;
  activatedRoute: any;
  checkboxValue = false;
  isScreenDisabled: any;
  navigationConfig: any;
  activatedRouteProjectId: any;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  searchData: any = '';
  sortColumnState: any;
  someSubscription: any;
  gridName: string = 'Project scenario consumer list';
  event: any;
  headerData = {
    materialName: 'Consumer',
  };
  StorageTypeEnum = StorageTypeEnum;
  scenarioId: any;
  packageScenarioId: any;
  menuDataForRouting: any;
  consumerList: any;
  eId: any;
  editConsumerSuccess: Subscription;
  deleteConsumer: Subscription;
  subscriptionInline!: Subscription;
  backRouteType: any;
  showEdit: boolean = false;
  constructor(
    private projectScenarioConsumerDataGridService: ProjectScenarioConsumerDataGridService,
    private projectService: ProjectsService,
    private viewportScroller: ViewportScroller,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private sharedService: SharedService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private modal: CustomModalService,
    private projectScenarioRetailDataGridService: ProjectScenarioRetailDataGridService,
    private toaster: ToastrService,
    private accessService: AccessPermissionService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
      this.getConsumerList();
    });

    this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });
    this.columnDefs = this.projectScenarioConsumerDataGridService.projectScenarioConsumerData();
    this.projectScenarioConsumerPayload = this.projectScenarioConsumerDataGridService.getPayload(
      this.searchData
    );

    this.editConsumerSuccess =
      this.projectScenarioConsumerDataGridService.editConsumerSuccessData$.subscribe(
        async editData => {
          this.getConsumerList();
        }
      );

    this.deleteConsumer = this.projectScenarioConsumerDataGridService.deleteConsumerData$.subscribe(
      async deleteData => {
        this.deleteConsumerData(deleteData[0]);
      }
    );
  }

  ngOnInit(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.subscriptionInline =
      this.projectScenarioConsumerDataGridService.inlineEditingObservable$.subscribe(
        (inlineData: any) => {
          this.inlineDataEditing(inlineData);
        }
      );
  }

  inlineDataEditing(payload: any) {
    this.projectService
      .projectRetailAndConsumerInlineEdit(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getConsumerList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  async getConsumerList() {
    const consumerList = (
      await this.projectService.getMyAllProjectScenarioConsumerListAsync(
        this.StorageTypeEnum.Consumer,
        this.scenarioId,
        this.activatedRouteProjectId
      )
    ).data;
    consumerList?.consumerList.map((item: any) => {
      item.storageTransportDetail.map((data: any) => {
        data['cityName'] = data.originName;
      });
    });
    this.consumerList = consumerList;
    this.checkboxValue = this.consumerList?.isExcludeConsumer;
    this.isScreenDisabled = this.consumerList?.isLockProject;
    this.navigationConfig = {
      scenarioId: this.scenarioId,
      packageScenarioId: this.packageScenarioId,
      eId: this.eId,
      activatedRouteProjectId: this.activatedRouteProjectId,
      activatedRoute: this.activatedRoute,
      isProjectLocked: this.isScreenDisabled,
      isProductPage: true,
    };
  }

  onCheckboxChange(eve: any) {
    this.checkboxValue = eve.target.checked ? true : false;
    this.projectService.disableConsumer(this.checkboxValue, this.scenarioId).subscribe();
  }

  async addCustomConversion(scenarioId: any, id: any, storageTypeId: any, label?: any) {
    let response = await this.projectService.openAddEditModalDataForProjectScenarioConsumerAsync(
      scenarioId,
      id,
      storageTypeId
    );
    this.modal.invoke('newAddProjectScenarioRetail', {
      initialState: {
        newMyProjectsPackRetail: response.data,
        label: label,
        pathName: this.activatedRoute,
        addTransportScenarioColDef:
          this.projectScenarioRetailDataGridService.getTransportModalForManualLocationDataColumn(),
        distanceProcessColumnDef:
          this.projectScenarioRetailDataGridService.getTransportModalForManualDestinationDataColumn(),
        customTransportColumnDef:
          this.projectScenarioRetailDataGridService.getCustomTransportItemsList(),
        customEolDef: this.projectScenarioRetailDataGridService.getendOfLifeDataColumn(),
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProjectPackRetailEvent.subscribe(
      (saveNewMyProjectPackRetailEvent: any) => {
        this.addConsumerData(saveNewMyProjectPackRetailEvent);
      }
    );
  }

  editRecord(record: any) {
    this.projectFacade.inlineDataEditForProject(
      record[0],
      record[1].scenarioId,
      this.activatedRoute
    );
  }

  addConsumerData(data: any) {
    this.projectService
      .addEditMyAllProjectPackConsumerData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.getConsumerList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  deleteConsumerData(data: any) {
    this.projectService
      .deleteProjectPackConsumerList(data.id)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getConsumerList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  ngOnDestroy() {
    this.deleteConsumer.unsubscribe();
    this.editConsumerSuccess.unsubscribe();
  }
}
